<template>
  <div>
    <div
      class="show-modal-button-holder"
      @click="show"
    >
      <naj-button
        v-if="buttonText"
        :disabled="disabled"
        :size="buttonSize"
        color="primary"
        class="show-modal-button"
        v-bind="{ outlined: buttonOutlined }"
      >
        {{ buttonText }}
      </naj-button>

      <slot
        v-else
        name="showButton"
      />
    </div>
    <transition name="fade">
      <div
        v-show="!disabled && dialog"
        class="modal-container"
        @click.self="close($event, persistent)"
      >
        <div
          class="modal-content"
          :style="{ 'max-width': width + 'px' }"
        >
          <horizontal-naj-box
            :no-header="!header"
            :title="title"
            :header-icon="closeButton ? 'mdi-close' : ''"
            :no-gutters="noGutters"
            :has-footer="footer || showFooterCloseButton"
            :no-bottom-margin="true"
            :inside-modal="true"
            :disable-collapsing="true"
            @iconClick="close"
          >
            <slot :closeNajModal="close" />
            <template v-slot:footer>
              <div class="naj-modal-actions">
                <naj-button
                  v-if="showFooterCloseButton"
                  outlined
                  @click="close"
                >
                  {{
                    local.common.close
                  }}
                </naj-button>
                <slot
                  name="actions"
                  :closeNajModal="close"
                />
              </div>
            </template>
          </horizontal-naj-box>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'NajModal2',
  props: {
    width: {
      required: false,
      default: 900,
    },
    header: {
      type: Boolean,
      default: true,
      required: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    buttonText: {
      type: String,
      required: false,
    },
    buttonSize: {
      type: String,
      required: false,
    },
    footer: {
      type: Boolean,
      default: false,
      required: false,
    },
    closeButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    noGutters: {
      type: Boolean,
      default: false,
      required: false,
    },
    persistent: {
      type: Boolean,
      default: false,
      required: false,
    },
    showFooterCloseButton: {
      type: Boolean,
      default: false,
    },
    buttonOutlined: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return { dialog: false };
  },
  methods: {
    show() {
      if (this.disabled) return;
      this.dialog = true;
    },
    close(event, preventClose = false) {
      if (preventClose) return;
      this.dialog = false;
      this.$emit('onClose');
    },
    inputEventHandler($event) {
      this.$emit('input', $event);
      !$event && this.$emit('onClose');
    },
  },
};
</script>

<style lang="scss" scoped>
.show-modal-button-holder {
  display: inline-block;
}
.naj-modal-actions {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: flex-end;
  width: 100%;
}
::v-deep .close-modal-button {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  padding: 20px;
  border-right: 1px solid #f4f5f8;
  color: #d0021b;
}

/******* this is he style of our modal component *******/
.modal-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 202;

  display: flex;
  align-items: center;
  justify-items: center;

  padding: 24px;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.5);
  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
  }
  &.fade-enter-active,
  &.fade-leave-active {
    transition: opacity 0.25s;
  }
  .modal-content {
    width: 100%;
    max-height: 90%;
    margin: 20px auto;
    box-sizing: border-box;
    overflow-y: auto;
  }
}
</style>
